import { render, staticRenderFns } from "./player-pullup.vue?vue&type=template&id=1a76fea2&"
import script from "./player-pullup.ts?vue&type=script&lang=ts&"
export * from "./player-pullup.ts?vue&type=script&lang=ts&"
import style0 from "./player-pullup.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports